import {motion} from 'framer-motion';

export default function MainSection() {
  return (
    <section
      data-bg-type='colorful'
      className='w-full h-screen flex flex-col justify-end px-[25px] py-[60px] lg:px-[150px] lg:py-[120px] text-white '
    >
      <video autoPlay muted loop playsInline
             className='absolute inset-0 z-[-1] w-full h-screen object-cover'>
        <source type='video/mp4'
                src={`${process.env.REACT_APP_STATIC_URL}/images/Main/Main_Section_Background_Video.mp4`}/>
      </video>

      <h1 className='text-title3 lg:text-display2 '>
        ICT 기술로 고객에게 안전과 편리함을<br/>
        제공하는 기업, 모듈링크
      </h1>

      <div className='flex flex-col items-center mt-[36px] text-body2'>
        <svg width="12" height="50" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <motion.path
            d="M1 1.5L8 8.5L15 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            initial={{opacity: 0, y: 0}}
            animate={{
              opacity: [0, 1, 0],
              y: [0, 0, 20],
              transition: {
                repeat: Infinity,
                ease: 'easeInOut',
                duration: 1.5,
                delay: 1
              }
            }}
          />
        </svg>
        <div>
          Scroll
        </div>
      </div>
    </section>
  )
}